import { useEffect, useState } from 'react';

export const FLASH_MS = 2400;

/** A value that clears itself after `ms`, for "Saved"-style confirmations. */
export function useFlash<T>(ms: number = FLASH_MS): [T | null, (value: T | null) => void] {
    const [value, setValue] = useState<T | null>(null);
    useEffect(() => {
        if (value === null) return;
        const timer = setTimeout(() => setValue(null), ms);
        return () => clearTimeout(timer);
    }, [value, ms]);
    return [value, setValue];
}
